import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function saveStep(step){
    const paso = await axios.get(
        `${REACT_APP_API}/url`,
    
    )
    return paso
}